import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStatusBarMenuStyles = makeStyles(({ spacing }) =>
  createStyles({
    icon: {
      display: 'flex',
      height: '100%',
      verticalAlign: 'middle',
      marginRight: spacing(2),
    },
    fullSize: { height: '100%', width: '100%' },
    moduleIcon: {
      paddingTop: spacing(2),
    },
  })
);

export default useStatusBarMenuStyles;
